import React, { useState } from 'react';
import minusSvg from '../../../assets/images/plan-comparison/svg/minus.svg'
import plusSvg from '../../../assets/images/plan-comparison/svg/plus.svg'
import infoSvg from '../../../assets/images/plan-comparison/svg/info.svg'
import planComparisonData from '../data-renderer/PlanComparisonData';
import Tooltip from '../../../components/Tooltip';

function PlanComparisonMobile() {
    const [expandedSection, setExpandedSection] = useState('');

    const toggleSection = (section) => {
        setExpandedSection(prev => prev === section ? null : section);
    };

    const renderCollapsibleSection = (title, content, section) => (
        <>
            <tr
                className="cursor-pointer bg-[#E6F3FF]"
                onClick={() => toggleSection(section)}
            >
                <td colSpan="3" className="p-3">
                    <div className="flex items-center justify-between w-full">
                        <span>{title}</span>
                        <img
                            src={expandedSection === section ? minusSvg : plusSvg}
                            alt={expandedSection === section ? "minus" : "plus"}
                        />
                    </div>
                </td>
            </tr>
            {expandedSection === section && content}
        </>
    );

    const renderRow = (item) => {
        const plans = ['pratham', 'uttam', 'param'];
        const isPratham = item.hasOwnProperty(plans[0]);
        const isUttam = item.hasOwnProperty(plans[1]);
        const isParam = item.hasOwnProperty(plans[2]);

        const isOnlyPratham = isPratham && !isUttam && !isParam;
        const notUttam = isPratham && !isUttam && isParam;
        const notParam = isPratham && isUttam && !isParam;

        return (
            <>
                <tr>
                    <td colSpan={2} className="p-3 border font-bold">
                        <p className='flex items-center justify-between'>
                            <span>{item.particular}</span>
                            {item.isInfo && (
                                <Tooltip content={item}>
                                    <img
                                        src={infoSvg}
                                        alt="info"
                                        className='h-6 w-6 cursor-pointer'
                                    />
                                </Tooltip>
                            )}
                        </p>
                    </td>
                </tr>
                <tr>
                    <td className="p-3 border text-orange-500 capitalize">Pratham</td>
                    {isPratham && (
                        <td
                            className="p-3 border"
                            rowSpan={isOnlyPratham ? 3 : (notUttam ? 2 : 1)}
                        >
                            {item.pratham}
                        </td>
                    )}
                </tr>
                <tr>
                    <td className="p-3 border text-orange-500 capitalize">Uttam</td>
                    {isUttam && (
                        <td
                            className="p-3 border"
                            rowSpan={notParam ? 2 : 1}
                        >
                            {item.uttam}
                        </td>
                    )}
                </tr>
                <tr>
                    <td className="p-3 border text-orange-500 capitalize">Param</td>
                    {isParam && (
                        <td className="p-3 border">
                            {item.param}
                        </td>
                    )}
                </tr>
            </>
        );
    };

    const groupedData = planComparisonData.reduce((acc, item) => {
        const group = item.id <= 4 ? 'eligibility' :
            item.id <= 12 ? 'baseCovers' :
                item.id <= 15 ? 'valueAddedCovers' :
                    item.id <= 29 ? 'optionalCovers' : 'addOnCovers';
        if (!acc[group]) acc[group] = [];
        acc[group].push(item);
        return acc;
    }, {});

    return (
        <div className='block lg:hidden px-4 py-6'>
            <h1 className="text-2xl leading-9 font-semibold text-center mb-6 text-[#27506E]">
                Plan Comparison
            </h1>
            <table className="w-full border-collapse">
                <thead>
                    <tr>
                        <th colSpan="2" className="text-left p-3 bg-gray-100">Plan Comparison</th>
                    </tr>
                </thead>
                <tbody>
                    {renderRow(groupedData.eligibility[0])}

                    {renderCollapsibleSection("Eligibility", (
                        <>
                            {groupedData.eligibility.slice(1).map(item => renderRow(item))}
                        </>
                    ), "eligibility")}

                    {renderCollapsibleSection("Base Covers", (
                        <>
                            {groupedData.baseCovers.map(item => renderRow(item))}
                        </>
                    ), "baseCovers")}

                    {renderCollapsibleSection("Value Added Covers", (
                        <>
                            {groupedData.valueAddedCovers.map(item => renderRow(item))}
                        </>
                    ), "valueAddedCovers")}

                    {renderCollapsibleSection("Optional Covers", (
                        <>
                            {groupedData.optionalCovers.map(item => renderRow(item))}
                        </>
                    ), "optionalCovers")}

                    {renderCollapsibleSection("Add - On Covers", (
                        <>
                            {groupedData.addOnCovers.map(item => renderRow(item))}
                        </>
                    ), "addOnCovers")}
                </tbody>
            </table>
        </div>
    );
}

export default PlanComparisonMobile;